import {Component, EventEmitter} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {StateService} from "../../services/StateService";
import {State} from "../../models/State";
import {SwitchBoard} from "../../services/SwitchBoard";
import {PageTitleService} from "../../services/PageTitle";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss'
})
export class ReportsComponent {
  destroy$: EventEmitter<void> = new EventEmitter<void>();

  constructor(private switchBoard: SwitchBoard, private _router: Router, private titleService: PageTitleService,
              private stateService: StateService, private _route: ActivatedRoute) {
    this.titleService.setPageTitle('Reports');
    this.switchBoard.onPageChangeListener.next({
      url: this._route.url,
      name: 'Reports',
      id: 'REPORTS'
    });
    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$)).subscribe(title => {
      this.gotoDefaultPage();
    });
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    this.stateService.pop();
    this._router.navigate([prevState.url]);
  }

  showPage(page, $event) {
    $event && $event.stopImmediatePropagation();
    switch (page) {
      case 'user-history-report': {
        this.addCurrentState();
        const link = ['tax-planning/user-history-report'];
        this._router.navigate(link);
      }
        break;
      case 'feedback-report': {
        this.addCurrentState();
        const link = ['tax-planning/feedback-report'];
        this._router.navigate(link);
      }
        break;
    }
  }

  addCurrentState() {
    this.stateService.addState(new State('Reports', this._router.url, null, []));
  }

}
